(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mws-product-edit"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-mws-product-list]').forEach((section) => {
    if (section.dataset.analyticsReady === 'true') return;
    section.dataset.analyticsReady = 'true';
    const cards = Array.from(section.querySelectorAll('[data-product-id]'));
    const items = cards.map((card, index) => ({
      item_id: card.dataset.productId,
      item_name: card.dataset.productTitle,
      index
    }));
    if (window.dataLayer && items.length) {
      window.dataLayer.push({ event: 'view_item_list', ecommerce: { item_list_name: section.dataset.mwsProductList, items } });
    }
    cards.forEach((card, index) => {
      card.querySelector('a')?.addEventListener('click', () => {
        if (window.dataLayer) {
          window.dataLayer.push({ event: 'select_item', ecommerce: { item_list_name: section.dataset.mwsProductList, items: [items[index]] } });
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
